<template>
  <right-menu-item
    v-if="show"
    @click.prevent="click"
    :class="{ 'muted': !isActive }"
    :text="$t('Download ZIP')"
    :loading="loading"
    icon="download"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { FolderApi } from '@/frontapp/test-api'
import Toast from '@/frontapp/mixins/actions/Toast'
// import { trackEvent } from '../../gtm'
import handleApiError from '../../utils/handleApiError'

const folderApi = new FolderApi({}, '/api/v2')

export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    show() {
      if (!this.$presenter.brandcloud.is_zip_enabled) {
        return false
      }
      
      const list = this.bcFolderStore?.current?.id === 0 ? this.bcFolderStore.listChildren[0] : [...this.bcSelectedStore.selectableMap.values()]
      if (list) {
        for (let index = 0; index < list.length; index++) {
          if (list[index].can_edit) {
            return true
          }
        }
      }

      return false
    },
    isActive() {
      return  this.bcSelectedStore.listSelected.length > 0 && this.bcSelectedStore.listSelected.every(item => item.can_edit)
    },
    ...mapStores(useBcSelectedStore, useBcFolderStore)
  },
  methods: {
    async click() {
      this.loading = true
      const documentIds = this.bcSelectedStore.listSelected
        .filter(e => e.type === 'document')
        .map(e => e.id)

      const folderIds = this.bcSelectedStore.listSelected
        .filter(e => e.type === 'folder')
        .map(e => e.id)

      await handleApiError(() => folderApi.folderRequestZipDownload({ folderIds, documentIds }))
      this.bcSelectedStore.reload()
      this.loading = false

      Toast(
        'success',
        this.$t('Your ZIP request will be prepared in a while. You will get notification in your mailbox when ZIP will be prepared.')
      )

      // trackEvent(this.$route.matched[0].name, 'trash')
    }
  }
}
</script>

<style lang="scss" scoped></style>
